import { render, staticRenderFns } from "./ServiceUpdate.vue?vue&type=template&id=4bd6b2d4&scoped=true"
import script from "./ServiceUpdate.vue?vue&type=script&lang=ts"
export * from "./ServiceUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd6b2d4",
  null
  
)

export default component.exports